module.exports = __webpack_public_path__ + "static/media/billet10.32173a4a.webp";